export default {
    meta: {
        title: '鱼你在一起-机会点表单页',
        url: '/fishtogether/chancepointlist',
        urlName: '鱼你机会点'
    }
};
